"use client";

import { Product } from "@/backend/services/products";
import { ProductCard } from "@/components/shared/shop/product-card";

function ProductCarousel({ products }: { products: Product[] }) {
  return (
    <div className="relative flex flex-row w-full snap-x snap-mandatory gap-4 overflow-x-auto pb-10 pt-2">
      {products?.map((product, idx) => {
        const variant = product.variants.find((d) => d.isDefault)!;
        return (
          <ProductCard
            key={variant.id}
            id={product.shortid}
            title={product.title}
            scrollHint={idx === 0}
            images={variant.images?.length ? variant.images : [product.image]}
            description={product.description ?? ""}
            price={variant.price}
            strikePrice={variant.strikePrice}
            variants={product.variants}
            options={product.options}
            vat={variant.vat}
            className="max-w-[450px] basis-72"
          />
        );
      })}
    </div>
  );
}

export default ProductCarousel;
